module.exports = __webpack_public_path__ + "img/cuffs_pl_white.9d8a6d19.png";